/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Trust_CenterInputs */



/**
* | output |
* | --- |
* | "Trust Center" |
*
* @param {Login_Trust_CenterInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_trust_center = /** @type {((inputs?: Login_Trust_CenterInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Trust_CenterInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Trust Center")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trust Center")
	return /** @type {LocalizedString} */ ("Trust Center")
});